module.exports = __webpack_public_path__ + "img/kaka.ec931c63.png";